<alii-web-spinner-loading *ngIf="(loading$ | async)"></alii-web-spinner-loading>
<div *ngIf="(profile$ | async) as profile">
    <alii-web-profile-form
        *ngIf="profile.id"
        [profile]="profile"
        [dashboards]="dashboards$ | async"
        (submit)="handleSubmit($event)"
    ></alii-web-profile-form>
</div>
